export interface Service {
  id: string;
  name: string;
  slug: string;
  shortDescription: string;
}

export const services: Service[] = [
  {
    id: 's-01',
    name: 'Rohrreinigung',
    slug: 'rohrreinigung',
    shortDescription: 'Professionelle und schnelle Rohrreinigung für verstopfte Abflüsse und Kanäle.'
  },
  {
    id: 's-02',
    name: 'Klempner Notdienst',
    slug: 'klempner-notdienst',
    shortDescription: '24/7 Klempner Notdienst für Rohrbrüche, Wasserschäden und akute Probleme.'
  },
  {
    id: 's-03',
    name: 'Sanitär',
    slug: 'sanitaer',
    shortDescription: 'Fachgerechte Sanitärinstallationen, Reparaturen und Wartung.'
  }
];
